<template>
  <div>
    <login v-if="login" />
    <register v-if="register" />
    <forgot-password v-if="forgot" />
    <reset-password v-if="reset" />
  </div>
</template>
<script>
import Login from "@/views/auth/Login.vue";
import Register from "@/views/auth/Register.vue";
import ForgotPassword from "@/views/auth/ForgotPassword.vue";
import ResetPassword from "@/views/auth/ResetPassword.vue";

export default {
  name: "NotSignedIn",
  components: {
    Login,
    Register,
    ForgotPassword,
    ResetPassword,
  },
  computed: {
    register: function () {
      return this.$route.name == "register" ? true : false;
    },
    login: function () {
      return this.$route.name == "login" ? true : false;
    },
    reset: function () {
      return this.$route.name == "resetPassword";
    },
    forgot: function () {
      return this.$route.name == "forgotPassword";
    },
  },
};
</script>
